module.exports = __webpack_public_path__ + "static/media/snapchat-ghost.e9283cd9.svg";